module.exports = __webpack_public_path__ + "media/assets/images/payment/discover-98da109e7fe322d3734772ab3a1ea1ba.png";